import {Dashboard} from "./lq_js_common/dashboard/dashboard";
import {TimePicker} from "./components/time_picker";
import {loadTrainingSnapshot, applyTrainingSnapshot} from "./training_snapshot";
import {loadTrainingCopy, initTrainingOverlay} from "./training_overlay";
import {ShaperCircuitThroughput} from "./dashlets/shaper_circuit/shaper_circuit_throughput";
import {ShaperCircuitHeaderDashlet} from "./dashlets/shaper_circuit/shaper_circuit_header";
import {ShaperCircuitRetransmits} from "./dashlets/shaper_circuit/shaper_circuit_retransmits";
import {ShaperCircuitCake} from "./dashlets/shaper_circuit/shaper_circuit_cake";
import {ShaperCircuitRtt} from "./dashlets/shaper_circuit/shaper_circuit_rtt";
import {ShaperCircuitAsn} from "./dashlets/shaper_circuit/shaper_circuit_asn";
import {ShaperCircuitAsnSankey} from "./dashlets/shaper_circuit/shaper_circuit_asn_sankey";
import {ShaperCircuitAsnMap} from "./dashlets/shaper_circuit/shaper_circuit_asn_map";
import {ShaperCircuitTimeline} from "./dashlets/shaper_circuit/shaper_circuit_timeline";
import {ShaperCircuitLive} from "./dashlets/shaper_circuit/shaper_circuit_live";
import {ShaperCircuitFunnel} from "./dashlets/shaper_circuit/shaper_circuit_funnel";
import {ShaperCircuitDevices} from "./dashlets/shaper_circuit/shaper_circuit_devices";
import {ShaperCircuitUpgradeAnalysis} from "./dashlets/shaper_circuit/shaper_circuit_upgrade_analysis";
import {renderTrainingNavigation} from "./components/navbar";
import {createExplainController, setupLibbyExplainButton} from "./helpers/ai_explain";

const SNAPSHOT_URL = "/training/snapshots/shaper_circuit.json";
const COPY_URL = "/training/training_copy.json";

function forceDarkMode() {
    try {
        localStorage.setItem("theme", "dark");
    } catch (e) {
        // no-op
    }
    document.documentElement.setAttribute("data-bs-theme", "dark");
    document.body.classList.add("dark-mode");
}

function buildTagToTabIndex(layout) {
    const map = {};
    layout.tabs.forEach((tab, idx) => {
        tab.dashlets.forEach((dashlet) => {
            if (map[dashlet.tag] === undefined) {
                map[dashlet.tag] = idx;
            }
        });
    });
    return map;
}

forceDarkMode();
window.nodeId = "0";
window.circuitId = "0";

const defaultLayout = {
    version: 2,
    tabs: [
        {
            name: "Overview",
            dashlets: [
                { tag: "shaperCircuitHeader", size: 12 },
                { tag: "circuitUpgradeAnalysis", size: 12 },
                { tag: "circuitAsnSankeyDownload", size: 6 },
                { tag: "circuitAsnSankeyUpload", size: 6 },
                { tag: "circuitAsnMapDownload", size: 6 },
                { tag: "circuitAsnMapUpload", size: 6 },
            ]
        },
        {
            name: "Circuit Performance",
            dashlets: [
                { tag: "circuitThroughput", size: 12 },
                { tag: "circuitRetransmits", size: 6 },
                { tag : "shaperCircuitCake", size: 6 },
                { tag: "shaperCircuitRtt", size: 12 },
            ]
        },
        {
            name: "ASN Analysis",
            dashlets: [
                { tag: "shaperCircuitAsn", size: 12 },
            ]
        },
        {
            name: "Timeline",
            dashlets: [
                { tag: "circuitTimeline", size: 12 },
            ]
        },
        {
            name: "Devices",
            dashlets: [
                { tag: "circuitDevices", size: 12 },
            ]
        },
        {
            name: "Live",
            dashlets: [
                { tag: "circuitLive", size: 12 },
            ]
        },
        {
            name: "Network Funnel",
            dashlets: [
                { tag: "circuitFunnel", size: 12 },
            ]
        }
    ],
    activeTab: 0
};

const dashletMenu = [
    { name: "Circuit Header", tag: "shaperCircuitHeader", size: 12 },
    { name: "Upgrade Analysis", tag: "circuitUpgradeAnalysis", size: 12 },
    {name: "Circuit Throughput", tag: "circuitThroughput", size: 12},
    {name: "Circuit Retransmits", tag: "circuitRetransmits", size: 6},
    {name: "CAKE Activity", tag: "shaperCircuitCake", size: 6},
    {name: "Round Trip Time", tag: "shaperCircuitRtt", size: 12},
    {name: "Circuit ASN Overview", tag: "shaperCircuitAsn", size: 6},
    {name: "Circuit ASN Sankey (Download)", tag: "circuitAsnSankeyDownload", size: 6},
    {name: "Circuit World Map (Download)", tag: "circuitAsnMapDownload", size: 12},
    {name: "Circuit ASN Sankey (Upload)", tag: "circuitAsnSankeyUpload", size: 6},
    {name: "Circuit World Map (Upload)", tag: "circuitAsnMapUpload", size: 12},
    {name: "Circuit Timeline", tag: "circuitTimeline", size: 12},
    {name: "Circuit Live", tag: "circuitLive", size: 12},
    {name: "Network Funnel", tag: "circuitFunnel", size: 12},
    {name: "Devices", tag: "circuitDevices", size: 12},
];

function widgetFactory(widgetName, count) {
    let widget = null;
    switch (widgetName) {
        case "shaperCircuitHeader": widget = new ShaperCircuitHeaderDashlet(count); break;
        case "circuitUpgradeAnalysis": widget = new ShaperCircuitUpgradeAnalysis(count); break;
        case "circuitThroughput": widget = new ShaperCircuitThroughput(count); break;
        case "circuitRetransmits": widget = new ShaperCircuitRetransmits(count); break;
        case "shaperCircuitCake": widget = new ShaperCircuitCake(count); break;
        case "shaperCircuitRtt": widget = new ShaperCircuitRtt(count); break;
        case "shaperCircuitAsn": widget = new ShaperCircuitAsn(count); break;
        case "circuitAsnSankeyDownload": widget = new ShaperCircuitAsnSankey(count, "download"); break;
        case "circuitAsnMapDownload": widget = new ShaperCircuitAsnMap(count, "download"); break;
        case "circuitAsnSankeyUpload": widget = new ShaperCircuitAsnSankey(count, "upload"); break;
        case "circuitAsnMapUpload": widget = new ShaperCircuitAsnMap(count, "upload"); break;
        case "circuitTimeline": widget = new ShaperCircuitTimeline(count); break;
        case "circuitLive": widget = new ShaperCircuitLive(count); break;
        case "circuitFunnel": widget = new ShaperCircuitFunnel(count); break;
        case "circuitDevices": widget = new ShaperCircuitDevices(count); break;
        default: {
            console.log("I don't know how to construct a widget of type [" + widgetName + "]");
            return null;
        }
    }
    return widget;
}

const dashboard = new Dashboard("dashboard", "training_shaperCircuitDashboard_v1", defaultLayout, widgetFactory, dashletMenu, false, "", false);
dashboard.build();

// Inline Libby insights strip. Training has no chatbot backend, so the
// controller renders the structured summary locally.
function explainableReadyDashlets() {
    return dashboard.dashlets.filter((d) => typeof d.canExplain === "function" && d.canExplain()
        && typeof d.isExplainReady === "function" && d.isExplainReady());
}
const explainController = createExplainController({
    dashboard,
    page: "shaper_circuit",
    getContext: () => ({node_id: String(window.nodeId), circuit_id: String(window.circuitId)}),
    getExplainable: explainableReadyDashlets,
});
setupLibbyExplainButton(explainController);

window.timeGraphs = [];
window.timePicker = new TimePicker("timePicker");

(async () => {
    const tagToTabIndex = buildTagToTabIndex(defaultLayout);
    try {
        const snapshot = await loadTrainingSnapshot(SNAPSHOT_URL);
        if (snapshot?.ids?.node_id !== undefined) {
            window.nodeId = String(snapshot.ids.node_id);
        }
        if (snapshot?.ids?.circuit_id !== undefined) {
            window.circuitId = String(snapshot.ids.circuit_id);
        }
        if (snapshot?.data?.shaper_navigation) {
            const nav = snapshot.data.shaper_navigation;
            renderTrainingNavigation(nav.blob || [], window.nodeId, nav.is_flat || false);
        } else {
            renderTrainingNavigation([], window.nodeId, false);
        }
        const applied = applyTrainingSnapshot(dashboard, snapshot);
        if (applied === 0) {
            console.warn("Training snapshot is empty.");
        }
        explainController.markNeedsExplain();
    } catch (err) {
        console.error(err);
    }

    try {
        const copy = await loadTrainingCopy(COPY_URL);
        initTrainingOverlay({ copy, pageKey: "shaper_circuit", dashboard, tagToTabIndex });
    } catch (err) {
        console.error(err);
    }
})();
